// =========================================================
// * Vue Material Dashboard - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./views/App";

//import VueCookies from 'vue-cookies'


// router setup
import routes from "./routes/routes";

//Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
//import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

//Bootstrap
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

//Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faChargingStation, faExclamation, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// firebase
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// notification
import Notifications from 'vue-notification'
Vue.use(Notifications);

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAf_zO8UDHLHXzTeZ_QMcu5NBhEBOI0WqQ",
  authDomain: "dfdspv.firebaseapp.com",
  projectId: "dfdspv",
  storageBucket: "dfdspv.appspot.com",
  messagingSenderId: "980541795647",
  appId: "1:980541795647:web:41ab21b3689ace78def78a",
  measurementId: "G-PELDRKJ8LR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
Vue.prototype.$firebaseapp = app

// Add the public key generated from the console here.
//getToken(messaging, {vapidKey: "BOx-bfC2pFGI_cgDI1XuJltSFxnRDYKPTP4CjFL-zqUbNLnHkK_vbSG8iOEuy4U7QixEzPiYyb54Ot6Zq_LkQt8"});

library.add([faCheckCircle, faChargingStation, faExclamation, faExclamationTriangle, faTimes])
Vue.component('font-awesome-icon', FontAwesomeIcon)


import Chartist from "chartist";
import './registerServiceWorker'


Vue.prototype.$Chartist = Chartist;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
//Vue.use(Notifications);
Vue.use(VueAxios, axios);
//Vue.use(VueCookies);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;
//axios.defaults.origin = "http://localhost:5000"

//if backend return unauth
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
  }, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error.response.status === 401 && window.location.pathname != "/login") {
      // redirect to login page
      window.location.href = "/login?status=sessionExpire";
  }
  return Promise.reject(error);
})

/* class Router extends VueRouter {
  resolve(to, current, append) {
    const route = { ...to };
    route.params = { ...route.params, language: 'en' };
    return super.resolve(route, current, append);
  }
} */
// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

router.beforeEach(async(to,from,next)=>{
  if(to.path != '/login') {
    axios.post('/login_status')
    .then(function(data){
      if(data.data["status"] == true){
        next();
      }else{
        next("/login?status=sessionExpire")
      }
    })
    .catch(function(data){
      next("/login?status=sessionExpire");
    })
  }else{
    next();
  }
})



/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  data: {
    Chartist: Chartist
  }
});


